export const CURRENCY_SYMBOLS = { EUR: '€', USD: '$', GBP: '£' };

export const getCurrencySymbol = (code) =>
    CURRENCY_SYMBOLS[(code || 'EUR').toUpperCase()] || (code || 'EUR');

export const formatPrice = (amount, code) =>
    `${getCurrencySymbol(code)}${Number(amount || 0).toFixed(2)}`;
